import React from 'react'
import { Link } from 'react-router-dom';
export const Footer = () => {
    return (
        <>
            <div id="footer" className="sticky-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 col-sm-6">
                            <Link to="/"><img className="footer-logo" src="images/logo.png" alt="" /></Link>
                            <br /><br />
                        </div>
                        <div className="col-md-6 col-sm-6 ">
                            <h4>Links útiles</h4>
                            <ul className="footer-links">
                                <li><Link to="/SignIn">Iniciar Sesión</Link></li>
                                <li><Link to="/Register">Registrarse</Link></li>
                                <li><Link to="/privacyPolicy">Política de Privacidad</Link></li>
                            </ul>
                            <ul className="footer-links">
                                <li><Link to="/terms">Términos y condiciones</Link></li>
                                <li><Link to="/faq">FAQ</Link></li>
                                <li><Link to="/howitworks">¿Cómo funciona?</Link></li>
                            </ul>
                            <div className="clearfix"></div>
                        </div>
                        <div className="col-md-3  col-sm-12">
                            <h4>Contáctanos</h4>
                            <div className="text-widget">
                                E-Mail:<span> <a href="#">hola@listeo.com</a> </span><br />
                            </div>
                            <ul className="social-icons margin-top-20">
                                <li><a className="facebook" href="#"><i className="icon-facebook"></i></a></li>
                                <li><a className="instagram" href="#"><i className="icon-instagram"></i></a></li>
                                <li><a className="twitter" href="#"><i className="icon-twitter"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="copyrights">© 2023 Listeo. All Rights Reserved.</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}